import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { inject } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import type { GetFilter, GetPagination } from '@shared/interfacres/request-related';
import { CarouselImage, CarouselImageApi, ImageCreateData } from '@shared/interfacres/image';
import { CarouselManagerService } from '@data-access/manager/services/carousel-manager.service';
import { DEFAULT_PAGE_SIZE } from '@shared/constants/basic';
import { MatSnackBar } from '@angular/material/snack-bar';


interface CarouselImagesState {
  items: CarouselImage[];
  total: number;
  name: string;
  isLoading: boolean;
  filter: GetFilter;
  pagination: GetPagination;
}

const initialState: CarouselImagesState = {
  items: [],
  total: 0,
  name: '',
  isLoading: false,
  filter: { query: '', order: 'asc' },
  pagination: { page: 1, pageSize: DEFAULT_PAGE_SIZE }
};

export const CarouselImagesStore = signalStore(
  withState(initialState),

  withMethods((store, service = inject(CarouselManagerService), snackBar = inject(MatSnackBar)) => ({

    async getAll() {
      patchState(store, () => ({
        isLoading: true,
      }));

      const imagesData: CarouselImageApi[] = await firstValueFrom(service.getList());
      patchState(store, () => ({
        isLoading: false,
        items: imagesData.map(item => {
          return {
            ...item,
            image: item.public_url
          }
        }),
        total: imagesData.length
      }));
    },
    async create(data: ImageCreateData) {
      patchState(store, () => ({
        isLoading: true,
      }));

      try {
        await firstValueFrom(service.create(data));

        await this.getAll();

      } catch (e) {
        snackBar.open('Error during uploading', '', { duration: 2000, horizontalPosition: 'end', panelClass: 'error-toast' });
        console.error(e);
      } finally {
        patchState(store, () => ({
          isLoading: false
        }));
      }

    },
    async update(id: number, data: ImageCreateData) {
      patchState(store, () => ({
        isLoading: true,
      }));

      try {
        await firstValueFrom(service.update(id, data));
        await this.getAll();

      } catch (e) {
        snackBar.open('Error during update', '', { duration: 2000, horizontalPosition: 'end', panelClass: 'error-toast' });
        console.error(e);
      } finally {
        patchState(store, () => ({
          isLoading: false
        }));
      }
    },

    async delete(id: number) {
      patchState(store, () => ({
        isLoading: true,
      }));

      try {
        await firstValueFrom(service.delete(id));
        await this.getAll();


      } catch (e) {
        snackBar.open('Error during removing', '', { duration: 2000, horizontalPosition: 'end', panelClass: 'error-toast' });
        console.error(e);
      } finally {
        patchState(store, () => ({
          isLoading: false
        }));
      }
    },

  }))
);
